import { isAccountsReceivableModule } from 'frontend-container/components/Menu/utils/modules/accountsReceivable';
import { loadReactApp } from 'frontend-container/utils/externalResources/react';
import { registerApplication } from 'single-spa';

import { acConfig } from '@ac/library-utils/dist/declarations';

export const accountsReceivableAppName = 'frontend-accounts-receivable';
export const registerAccountsReceivable = (): void => {
  registerApplication(
    accountsReceivableAppName,
    () =>
      loadReactApp(
        acConfig.frontendUrls.accountsReceivable,
        accountsReceivableAppName
      ),
    (location: Location) => isAccountsReceivableModule(location.pathname)
  );
};
